import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib';
import {
  cancelCprResultRequest,
  failCprResult,
  setCprResult,
  setCprResultFromApi,
  updateCprResult,
  updateCprResultFromApi,
} from './cpr-result.actions';

/**
 * Service to handle async CprResult actions
 */
@Injectable()
export class CprResultEffect {
  /**
   * Set the state with the reply content, dispatch failCprResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setCprResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setCprResult({ model: reply, requestId: action.requestId }),
        (error, action) => of(failCprResult({ error, requestId: action.requestId })),
        cancelCprResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failCprResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCprResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateCprResult({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failCprResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
